import {Doughnut, mixins} from 'vue-chartjs'
const { reactiveProp } = mixins;

export default {
	extends: Doughnut,
	mixins: [reactiveProp],
	props: {
		chartData: Object,
		options: Object,
		value: {
			Number,
			default: 0
		},
		segmentStrokeStyle: {
			String,
			default: '#a5a5a5'
		},
		label: {
			String,
			default: 'PERCENT'
		},
		fontFamily: {
			String,
			default: "Roboto Condensed"
		}
	},
	mounted () {

		const {
			fontFamily,
			label,
			segmentStrokeStyle
		} = this;


		this.addPlugin({
			afterDatasetsDraw: function (chart) {
				const {
					config: {data: {datasets}},
					radiusLength,
				} = chart;

				const radiusSize = parseFloat(radiusLength.toFixed(4));

				if (datasets.length === 1) {
					const {ctx, width, height} = chart;
					const {data: [fillValue], centerLabelColor, centerLabelSize} = datasets[0];
					const centerX = width / 2;
					const centerY = height / 2;
					const ratio = height / 100;

					const segmentLinesCount = 12;
					const segmentLinesSize = ratio * 8;
					const segmentLinesTopOffset = segmentLinesSize / 2;
					const innerRadius = centerY - radiusSize - (segmentLinesSize + segmentLinesTopOffset);
					ctx.strokeStyle = segmentStrokeStyle;
					ctx.lineWidth = 1;

					ctx.save();
					ctx.beginPath();
					ctx.arc(centerX, centerY, centerY - radiusSize, 0, 2 * Math.PI, false);
					ctx.fillStyle = "#fff";
					ctx.fill();
					ctx.restore();

					for (let i = 0; i < segmentLinesCount; i++) {
						ctx.save();
						ctx.beginPath();
						ctx.translate(centerX, centerY);
						const angle = (i * 360 / segmentLinesCount) * Math.PI / 180;
						const startY = radiusSize + segmentLinesTopOffset;
						const endY = startY + segmentLinesSize;
						ctx.rotate(angle);
						ctx.translate(0.5, -height / 2);
						ctx.moveTo(0, startY);
						ctx.lineTo(0, endY);
						ctx.stroke();
						ctx.closePath();
						ctx.restore();
					}

					ctx.beginPath();
					ctx.arc(centerX, centerY, innerRadius, 0, 2 * Math.PI, false);
					ctx.strokeStyle = segmentStrokeStyle;
					ctx.stroke();
					ctx.font = `${ratio * (centerLabelSize || 20) }px ${fontFamily}`;
					ctx.textAlign = "center";
					ctx.textBaseline = "middle";
					ctx.fillStyle = centerLabelColor;
					ctx.fillText(fillValue, centerX, centerY);
					ctx.font = `${ratio * 6}px ${fontFamily}`;
					const offsetY = (ratio * 44 / 2);
					ctx.fillText(label, centerX, centerY + offsetY);
				}
			}
		});

		this.renderChart(this.chartData, this.options)
	}
}
